module.exports = __webpack_public_path__ + "img/dog-brown.e9c0dc73.jpg";